<div style="width: 100%" fxLayout="column">
  <div id="subnav" class="page-layout simple right-sidebar accent-400" fxLayout="row">
    <div class="center">
      <div class="header accent-400 p-4 pb-0" fxLayout="column" fxLayoutAlign="space-between">
        <div fxLayout="row">
          <div class="selected-project">{{ selected_role?selected_role:"பொறுப்புகள்" }}</div>

          <button mat-icon-button class="project-selector" [matMenuTriggerFor]="projectsMenu"
            aria-label="Select project">
            <mat-icon>more_horiz</mat-icon>
          </button>

          <mat-menu #projectsMenu="matMenu">
            <button mat-menu-item *ngFor="let party_post of getPartyPosts(); trackBy: trackByFn"
              (click)="onPartyPostChange(party_post)">
              <span>{{ party_post.party_post_subgroup_name }}</span>
              <span *ngIf="party_post.place_name != ''">(<span>{{ party_post.place_name }}</span>)</span>
            </button>
          </mat-menu>

          <div *ngIf="showBarracksDropDown" class="selected-project ml-4">
            <!-- {{ selected_barrack | translate }} -->
            {{ barrack_role?barrack_role: "பாசறைகள் " }}
          </div>

          <button *ngIf="showBarracksDropDown" mat-icon-button class="project-selector"
            [matMenuTriggerFor]="barracksMenu" aria-label="Select project">
            <mat-icon>more_horiz</mat-icon>
          </button>

          <mat-menu #barracksMenu="matMenu">
            <button mat-menu-item *ngFor="let barrack of barracks" (click)="onBarrackChange(barrack)">
              <span>{{ barrack.barrack_name }}</span>
            </button>
          </mat-menu>

          <div class="place">
            <p>{{ place }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-breadcrumbs></app-breadcrumbs>
</div>